import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { sendEvent } from 'app/services/event';

function BrowserRouterComponent({ children }) {
  return (
    <BrowserRouter>
      <ReportChangePageEvent>{children}</ReportChangePageEvent>
    </BrowserRouter>
  );
}

function ReportChangePageEvent({ children }) {
  const location = useLocation();

  const selectedPharmacyId = useSelector(
    ({ pharmacySelector }) => pharmacySelector.selectedPharmacyId
  );

  useEffect(() => {
    if (selectedPharmacyId) sendEvent(selectedPharmacyId, location.pathname, 'navigate');
  }, [selectedPharmacyId, location.pathname]);

  return children;
}

export default BrowserRouterComponent;
